import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <span className="manga-clip inline-flex items-center gap-2 bg-accent-500 px-3 py-1 text-sm font-bold text-foreground-950">
        <i className="ri-error-warning-line" />页面走丢了
      </span>
      <h1 className="mt-6 font-heading text-6xl text-foreground-950 md:text-8xl">
        4<span className="text-primary-500">0</span>4
      </h1>
      <p className="mt-3 text-base text-foreground-600">
        你访问的页面不存在，返回首页继续浏览游戏资讯与联动情报吧。
      </p>
      <p className="mt-1 font-mono text-sm text-foreground-400">{location.pathname}</p>
      <Link
        to="/"
        className="manga-clip mt-7 whitespace-nowrap bg-primary-500 px-6 py-3 text-base font-bold text-background-50 transition-colors hover:bg-primary-400"
      >
        返回首页
      </Link>
    </div>
  );
}